// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/element-reset.css
// module id = mFgs
// module chunks = 1